import { createSlice } from '@reduxjs/toolkit'
import { LOCATION_CHANGE } from 'connected-react-router'
import Location from 'interfaces/Location'
import { TypeBien } from 'interfaces/API'

export interface EtudierMarcheState {
  locations: Location[]
  typeBien: TypeBien[]
  surfaceTerrainMin: number
  surfaceTerrainMax: number | null
  surfaceHabitableMin: number
  surfaceHabitableMax: number | null
  montantMin: number
  montantMax: number | null
  nombrePieces: number[]
  startDate: Date | null
  endDate: Date | null
  displayMode: 'normal' | 'synthese'
}
export const initialState: EtudierMarcheState = {
  locations: [],
  typeBien: [TypeBien.Maison, TypeBien.Appartement, TypeBien.Terrain],
  surfaceTerrainMin: 0,
  surfaceTerrainMax: null,
  surfaceHabitableMin: 0,
  surfaceHabitableMax: null,
  montantMin: 0,
  montantMax: null,
  nombrePieces: [],
  startDate: null,
  endDate: null,
  displayMode: 'normal',
}

const name = 'etudierMarche'

const etudierMarcheSlice = createSlice({
  name,
  initialState,
  reducers: {
    // Redux Toolkit allows us to write "mutating" logic in reducers. It
    // doesn't actually mutate the state because it uses the Immer library,
    // which detects changes to a "draft state" and produces a brand new
    // immutable state based off those changes
    [LOCATION_CHANGE]: (state) => {
      state.displayMode = initialState.displayMode
    },
    updateLocations: (state, action) => {
      const locations = action.payload

      state.locations = locations
    },
    updateTypeBien: (state, action) => {
      const typeBien = action.payload

      if (state.typeBien.includes(typeBien)) {
        return {
          ...state,
          typeBien: state.typeBien.reduce(
            (acc: number[], cur: number) =>
              cur === typeBien ? acc : [...acc, cur],
            []
          ),
        }
      }
      return {
        ...state,
        typeBien: [...state.typeBien, typeBien],
      }
    },
    updateNombrePieces: (state, action) => {
      const piece = action.payload

      if (state.nombrePieces.includes(piece)) {
        return {
          ...state,
          nombrePieces: state.nombrePieces.reduce(
            (acc: number[], cur: number) =>
              cur === piece ? acc : [...acc, cur],
            []
          ),
        }
      }
      return {
        ...state,
        nombrePieces: [...state.nombrePieces, piece],
      }
    },
    updateHabitableMin: (state, action) => {
      const surfaceHabitableMin = action.payload

      state.surfaceHabitableMin = surfaceHabitableMin
    },
    updateHabitableMax: (state, action) => {
      const surfaceHabitableMax = action.payload

      state.surfaceHabitableMax = surfaceHabitableMax
    },
    updateTerrainMin: (state, action) => {
      const surfaceTerrainMin = action.payload

      state.surfaceTerrainMin = surfaceTerrainMin
    },
    updateTerrainMax: (state, action) => {
      const surfaceTerrainMax = action.payload

      state.surfaceTerrainMax = surfaceTerrainMax
    },
    updateMontantMin: (state, action) => {
      const montantMin = action.payload

      state.montantMin = montantMin
    },
    updateMontantMax: (state, action) => {
      const montantMax = action.payload

      state.montantMax = montantMax
    },
    updateStartDate: (state, action) => {
      const date = action.payload

      state.startDate = date
    },
    updateEndDate: (state, action) => {
      const date = action.payload

      state.endDate = date
    },
    resetFormulaire: (state) => ({
      ...state,
      ...initialState,
    }),
    toggleDisplayMode: (state, action) => {
      const displayMode = action.payload

      if (displayMode)
        return {
          ...state,
          displayMode,
        }

      return {
        ...state,
        displayMode: state.displayMode === 'normal' ? 'synthese' : 'normal',
      }
    },
  },
})

export const {
  updateLocations,
  updateTypeBien,
  updateNombrePieces,
  updateHabitableMin,
  updateHabitableMax,
  updateTerrainMin,
  updateTerrainMax,
  updateMontantMin,
  updateMontantMax,
  updateStartDate,
  updateEndDate,
  resetFormulaire,
  toggleDisplayMode,
} = etudierMarcheSlice.actions

export default etudierMarcheSlice
